import { ApiError, getCurrentWeather } from '../api/api';
import { toWeatherSlice, type OwmCurrent } from '../lib/openweather';
import type { DisplayStore } from './store';

export const WEATHER_REFRESH_MS = 30 * 60_000;

interface Options {
  store: DisplayStore;
  /** Spento = nessuna chiamata, meteo simulato del server. */
  enabled: boolean;
  lat: number;
  lon: number;
  fetcher?: (lat: number, lon: number) => Promise<OwmCurrent>;
  log?: (...args: unknown[]) => void;
}

/**
 * Legge il meteo da OpenWeather ogni 30 minuti e lo mette nello store. Da spento non fa nulla.
 * Se una lettura fallisce resta l'ultimo valore: oltre la soglia (src/lib/staleness.ts) il pannello
 * dice "non aggiornato".
 * Restituisce la funzione che ferma le letture.
 */
export function startLiveWeather(opts: Options): () => void {
  const { store, enabled, lat, lon, fetcher = getCurrentWeather, log = console.warn } = opts;
  if (!enabled) return () => {};

  let stopped = false;
  const refresh = async () => {
    try {
      const body = await fetcher(lat, lon);
      if (stopped) return;
      const slice = toWeatherSlice(body);
      if (slice.tempC === null && slice.sky === null) {
        log('[meteo] risposta di OpenWeather senza dati utili: scartata');
        return;
      }
      store.setWeather(slice);
    } catch (e) {
      const status =
        e instanceof ApiError || (e as { status?: number }).status !== undefined
          ? (e as { status: number }).status
          : 0;
      log(
        status === 401
          ? '[meteo] OpenWeather risponde 401: chiave non valida o non ancora attiva sul server (una chiave nuova può metterci un paio d’ore)'
          : `[meteo] lettura non riuscita (${status || 'rete'}): resta l’ultimo valore`,
      );
    }
  };

  void refresh();
  const id = setInterval(() => void refresh(), WEATHER_REFRESH_MS);
  return () => {
    stopped = true;
    clearInterval(id);
  };
}
